import { Check, Crown } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { StepHeader } from "@/components/apply/Field";
import { CashNotice } from "@/components/site/CashNotice";
import { useSiteSettings } from "@/context/SettingsContext";
import { money } from "@/lib/api";
import { ADDON_LABELS } from "@/data/options";
import { cn } from "@/lib/utils";

export const StepTier = ({ form, setForm }) => {
  const { settings } = useSiteSettings();
  const toggleAddon = (k) =>
    setForm((f) => ({ ...f, addons: f.addons.includes(k) ? f.addons.filter((a) => a !== k) : [...f.addons, k] }));
  return (
    <div data-testid="step-tier">
      <StepHeader title="Choose your membership" text="One-time fee. No monthly or annual fees." />
      <div className="grid gap-4 sm:grid-cols-2">
        {(settings?.tiers || []).map((t) => {
          const active = form.tier === t.key;
          return (
            <button
              type="button"
              key={t.key}
              onClick={() => setForm((f) => ({ ...f, tier: t.key }))}
              data-testid={`apply-tier-option-${t.key}`}
              className={cn(
                "relative text-left rounded-2xl border-2 p-5 transition-[border-color,transform,background-color] hover:-translate-y-0.5",
                active ? "border-primary bg-primary/10" : "border-border bg-card hover:border-primary/50"
              )}
            >
              {t.best_value && <span className="absolute top-4 right-4 inline-flex items-center gap-1 rounded-full bg-amber-400 text-[#0A1F13] px-2 py-0.5 text-[10px] font-extrabold"><Crown className="h-3 w-3" />Best Value</span>}
              <p className="font-display text-xl font-bold">{t.name}</p>
              <p className="text-sm text-muted-foreground">{t.intros_label}</p>
              <p className="mt-3 font-display text-2xl font-extrabold">{money(t.price)}</p>
              {active && <span className="absolute bottom-4 right-4 h-7 w-7 rounded-full bg-primary grid place-items-center"><Check className="h-4 w-4 text-primary-foreground" /></span>}
            </button>
          );
        })}
      </div>
      <div className="mt-8 rounded-2xl border border-border p-5 space-y-3">
        <p className="font-bold">Interested in add-on services?</p>
        <p className="text-sm text-muted-foreground">Quoted separately. Not included in membership pricing.</p>
        {Object.entries(ADDON_LABELS).map(([k, label]) => (
          <label key={k} className="flex items-center gap-3 cursor-pointer">
            <Checkbox checked={form.addons.includes(k)} onCheckedChange={() => toggleAddon(k)} data-testid={`apply-addon-${k}`} />
            <span className="font-semibold">{label}</span>
          </label>
        ))}
      </div>
      <CashNotice className="mt-6" testId="apply-tier-cash-notice" />
    </div>
  );
};
